//
// Mobile Container is a javascript class that instantiates an F2 container
// and loads all F2 apps that it can find on the page
// 
// This class relies on a "mod-td-mobile-f2-container" ID on the
// container element, and one or more elements inside of the container
// whose IDs are equal to their F2 app ID and have a ".f2-container" class.
//
// jQuery: 1.11.1
// F2: 1.4.0
//-------------------------------------------------------------------------

(function($, F2, window) {

	var MobileContainer_Class = function() {
		this._$container = $('#mod-td-mobile-f2-container');
		this._$fixedNav = $('#page-fixed-header');
		this._mobileLoader = new MobileLoader();
		this._token = F2.AppHandlers.getToken();

		this._init();
		this._registerApps();
	};

	MobileContainer_Class.prototype._init = function() {
		F2.AppHandlers.on(this._token, F2.Constants.AppHandlers.APP_CREATE_ROOT, function(appConfig) {
			appConfig.root = $('#' + appConfig.appId).get(0);
		});

		// show loading on f2 apps that need to be loaded
		F2.AppHandlers.on(this._token, F2.Constants.AppHandlers.APP_RENDER_BEFORE, $.proxy(function(appConfig) {
			this._mobileLoader.show();
		}, this));

		// hide loading
		F2.AppHandlers.on(this._token, F2.Constants.AppHandlers.APP_RENDER_AFTER, $.proxy(function(appConfig) {
			this._mobileLoader.hide();
		}, this));

		// render the app by inserting the html into the placeholder/root
		F2.AppHandlers.on(this._token, F2.Constants.AppHandlers.APP_RENDER, function(appConfig, appHtml) {
			appConfig.root.innerHTML = appHtml;
		});

		// init f2
		F2.init({
			xhr: {
				type: function() {
					return 'POST';
				}
			}
		});
	};
	// Event from any of the apps to dynamicly update the header test and back link
	MobileContainer_Class.prototype.handleHeaderUpdate = function(data) {

		if (data) {
			var $gearButton = this._$fixedNav.find('#DeliveryPrefrencesButton');
			var $refreshButton = this._$fixedNav.find('#RefreshButton');

			//Update title if there is one
			if (data.title && data.title != null) {
				this._$fixedNav.find('.htxt').text(data.title);
			}
			if (data.titleHtml) {
				this._$fixedNav.find('.htxt').replaceWith($(data.titleHtml));
			}
			//Update the back link if there is one
			if (data.backLink && data.backLink != null) {
				this._$fixedNav.find('#BackButton').attr('href', data.backLink);
			}
			//Update the refresh/gear icon href
			if (data.gearLink && data.gearLink != null) {
				//TODO not sure if this will need to be dynamic yet
			}
			//Update the refresh/gear icon href
			if (data.refreshLink && data.refreshLink != null) {
				$refreshButton.attr('href', data.refreshLink);
			}
			//Update the refresh/gear icon href
			if (data.refreshOnClick && data.refreshOnClick != null) {
				$refreshButton.attr('onclick', data.refreshOnClick);
			}
			// When the input is focused the header needs to be positioned absolute rather than fixed
			// passing the data object to the other handler to always reset the header style
			this.handleFixedElement(data);
			//Switch icons
			if (data.showGear) {
				$gearButton.removeClass('hide');
			} else {
				$gearButton.addClass('hide');
			}
			if (data.showRefresh) {
				$refreshButton.removeClass('hide');
			} else {
				$refreshButton.addClass('hide');
			}
		}
	};

	MobileContainer_Class.prototype.handleFixedElement = function(data) {
		if (data) {
			// When the input is focused the header needs to be positioned absolute rather than fixed
			// There are times that the container needs to be updated to allow the footer to move when 
			// there are alert items verses times when there are not.
			var $saveButton = this._$container.find('.submit-button').closest('.navbar-fixed-bottom');
			var $footer = this._$container.find('#suspend-delete-footer');
			var $alertsEditAlertsBody = this._$container.find('.create-edit-alerts');
			var $reviewAlertsBody = this._$container.find('.review-alerts');

			if (data.headerFloatFix) {
				this._$fixedNav.addClass('header-fix');
				$saveButton.addClass('save-button-fix');
				$alertsEditAlertsBody.addClass('save-button-fix');
			} else {
				this._$fixedNav.removeClass('header-fix');
				$saveButton.removeClass('save-button-fix');
				$alertsEditAlertsBody.removeClass('save-button-fix');
			}

			if (data.containerFloatFix) {
				$reviewAlertsBody.addClass('footer-fix');
			} else {
				$reviewAlertsBody.removeClass('footer-fix');
			}

			if (data.footerFloatFix) {
				$footer.addClass('footer-fix');
			} else {
				$footer.removeClass('footer-fix');
			}

		}
	};

	MobileContainer_Class.prototype._registerApps = function() {
		var apps = [];
		this._$container.find('.f2-container').each($.proxy(function(i, el) {
			var appObject = $(el).data('f2-app');

			apps.push({
				'appId': appObject.AppID,
				'context': appObject.Context || {},
				'manifestUrl': appObject.ManifestUrl,
				'maxWidth': $(window).width(),
			});
		}, this));

		// Some F2 event listeners so the apps can update the header in the 
		// container dynamicly to adjust the back link, heading, and top right icon
		F2.Events.on("UPDATE_HEADER", $.proxy(this.handleHeaderUpdate, this));
		// TDWM-859, TDWM-858, TDWM-800
		F2.Events.on("FIXED_ELEMENT", $.proxy(this.handleFixedElement, this));

		F2.registerApps(apps);
	};
	// Adding this to be able to use the exisitng NativeInteractions script.
	if (typeof window.WSOD == 'undefined') {
		window.WSOD = {};
	}

	window.MobileContainer = window.MobileContainer || new MobileContainer_Class();

})(jQuery, F2, window);